/* eslint-disable default-case */
/* eslint-disable no-extend-native */
import * as React from 'react';
import ReactDOM from 'react-dom';
import { GridComponent, ColumnsDirective, ColumnDirective, Toolbar, ExcelExport, DetailRow, PdfExport, Page, Filter, Inject, Sort } from '@syncfusion/ej2-react-grids';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective,  Legend, Category, Tooltip, LineSeries, DateTime, Trendlines, TrendlinesDirective, TrendlineDirective, ColumnSeries, DataLabel } from '@syncfusion/ej2-react-charts';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import { DataManager, Query } from '@syncfusion/ej2-data';
import { SampleBase } from './sample-base';
import * as CustomJS from '../Custom';
import _ from 'underscore/underscore-min';
import '../Custom.css';
import CurvaObiettivi from '../assets/CurvaObiettivi2022.json';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { random, isUndefined } from 'underscore';
Array.prototype.sum = function (prop, tipo) {
    let total = 0
    for ( let i = 0, _len = this.length; i < _len; i++ ) {
        if (this[i].Raggruppamento === tipo)
            total += this[i][prop];
    }
    return total;
}

Array.prototype.mediaPonderataMedie = function (campoMedia, campoNumerosita, tipo) {
    let mediaTotale = 0, pesoTotale = 0, numerositaTotale = 0;
    for ( var i = 0, _len = this.length; i < _len; i++ ) {
        if (this[i].Raggruppamento === tipo){
            pesoTotale += (this[i][campoMedia] * this[i][campoNumerosita]);
            //media = Math.round(((media * numerosita) + (this[i][campoMedia] * this[i][campoNumerosita]) / (numerosita + this[i][campoNumerosita])) * 100) / 100;
            numerositaTotale += this[i][campoNumerosita]; 
        }
    }   
    mediaTotale = numerositaTotale === 0 ? 0 : pesoTotale / numerositaTotale;
    return Math.round(mediaTotale * 100) / 100;
}

let periti = [];
var dataCorrente = new Date();
var dd = String(dataCorrente.getDate()).padStart(2, '0');
var mm = String(dataCorrente.getMonth() + 1).padStart(2, '0');
var yyyy = dataCorrente.getFullYear();
dataCorrente = yyyy.toString() + mm + dd;
let mesiChar = ['GENNAIO', 'FEBBRAIO', 'MARZO', 'APRILE', 'MAGGIO', 'GIUGNO', 'LUGLIO', 'AGOSTO', 'SETTEMBRE', 'OTTOBRE', 'NOVEMBRE', 'DICEMBRE'];
let ObietMeseRE = 0;
let ObietMeseRC = 0;
let GridData1 = [], GridData2 = [], ddlData = [];
let data1 = [], data2 = [], ObietMese = [], data3 = [], data4 = [];


    CustomJS.getRemoteData2(CustomJS.APIUrlProd,
        `token=${CustomJS.tokenProd}&azione=compagnie`, 
        'POST', "application/x-www-form-urlencoded", (retData) => {  
            ddlData = retData;         
    }, true, false);
    
    function caricaDati(thisClone) {
        GridData1 = []; GridData2 = []; data1 = []; data2 = []; data3 = []; data4 = [];
        let dataFineEstr = '';
        if (thisClone.ddlInstance2.value === mm)
            dataFineEstr = dataCorrente;
        else { 
            const meseEstr = thisClone.ddlInstance2.value;
            const giorno = (mm === '02') ? CustomJS.leapYear(yyyy.toString()) ? '29' : '28' : (meseEstr === '01' || meseEstr === '03' || meseEstr === '05' || meseEstr === '07' || meseEstr === '08' || meseEstr === '10' || meseEstr === '12') ? '31' : '30';            
            dataFineEstr = yyyy.toString() + thisClone.ddlInstance2.value + giorno;
        }
        ObietMeseRE = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RE'})[yyyy.toString() + thisClone.ddlInstance2.value]; 
        ObietMeseRC = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RC'})[yyyy.toString() + thisClone.ddlInstance2.value];
        //thisClone.toggleBlocking();
        CustomJS.getRemoteData2(CustomJS.APIUrlProd,
            `token=${CustomJS.tokenProd}&azione=scaricoCompagnie&raggruppamento=rerc&dataDa=${yyyy.toString()}0101&dataA=${dataFineEstr}`, 
            'POST', "application/x-www-form-urlencoded", (retData) => {   
                let groupedArr = _.groupBy(retData, 'IdCompagnia');
                let NumChiusiRE = 0, NumEntratiRE = 0, NumChiusiRC = 0, NumEntratiRC = 0;
                let TempoMedioScarRE = 0, TempoMedioScarRC = 0, PesoParzialeRE = 0, PesoParzialeRC = 0;
                Object.values(groupedArr).forEach((elm, idx) => {
                    NumChiusiRE = elm.sum('NumSinistriChiusi', 'RE');
                    NumEntratiRE = elm.sum('NumSinistriEntrati', 'RE');
                    NumChiusiRC = elm.sum('NumSinistriChiusi', 'RC');
                    NumEntratiRC = elm.sum('NumSinistriEntrati', 'RC');
                    TempoMedioScarRE = elm.mediaPonderataMedie('GiorniMediRientro', 'NumSinistriChiusi', 'RE');
                    TempoMedioScarRC = elm.mediaPonderataMedie('GiorniMediRientro', 'NumSinistriChiusi', 'RC');
                    GridData1.push({
                        IdCompagnia: Object.keys(groupedArr)[idx],
                        DescrCompagnia:_.find(ddlData, (obj) => { return obj.IdCompagnia.toString() === Object.keys(groupedArr)[idx]; })?.DescrizioneCompagnia,
                        ScarTotSinRE: ((NumChiusiRE / NumEntratiRE) * 100) < 100 && ((NumChiusiRE / NumEntratiRE) * 100) > 0 
                                        && (((NumChiusiRE / NumEntratiRE) * 100) - Math.floor(((NumChiusiRE / NumEntratiRE) * 100))) !== 0
                                    ? ((NumChiusiRE / NumEntratiRE) * 100).toFixed(2)
                                    : ((NumChiusiRE / NumEntratiRE) * 100).toFixed(0),
                        NumSinistriMancantiRE: NumChiusiRE - calcolaSinistriObiettivo(NumEntratiRE, 'RE'),
                        TempoMedioScaricoRE: TempoMedioScarRE,
                        ScarTotSinRC: ((NumChiusiRC / NumEntratiRC) * 100) < 100 && ((NumChiusiRC / NumEntratiRC) * 100) > 0 
                                        && (((NumChiusiRC / NumEntratiRC) * 100) - Math.floor(((NumChiusiRC / NumEntratiRC) * 100))) !== 0
                                    ? ((NumChiusiRC / NumEntratiRC) * 100).toFixed(2)
                                    : ((NumChiusiRC / NumEntratiRC) * 100).toFixed(0), 
                        NumSinistriMancantiRC: NumChiusiRC - calcolaSinistriObiettivo(NumEntratiRC, 'RC'),
                        TempoMedioScaricoRC: TempoMedioScarRC
                    }); 
                });    
                GridData1 = _.sortBy(GridData1, obj => { return obj.NumSinistriMancantiRE + obj.NumSinistriMancantiRC; });
                let sortedArr = _.sortBy(retData, ['IdPerito', 'IdCompagnia']);
                sortedArr = _.filter(sortedArr, obj => { return obj.NominativoPerito !== "TOTALI" });
                let salvaIdPerito = '', salvaIdCompagnia = '', salvaNomePerito = '';
                NumChiusiRE = 0; NumEntratiRE = 0; PesoParzialeRE = 0;
                NumChiusiRC = 0; NumEntratiRC = 0; PesoParzialeRC = 0;
                sortedArr.forEach((elm) => { 
                    if ((!CustomJS.isNullEmpty(salvaIdPerito) && elm.IdPerito !== salvaIdPerito) || (!CustomJS.isNullEmpty(salvaIdCompagnia) && elm.IdCompagnia !== salvaIdCompagnia)) {
                        GridData2.push({
                            IdCompagnia: salvaIdCompagnia,
                            IdPerito: salvaIdPerito,
                            NominativoPerito: salvaNomePerito,                    
                            ScarTotSinRE: ((NumChiusiRE / NumEntratiRE) * 100) < 100 && ((NumChiusiRE / NumEntratiRE) * 100) > 0 
                                            && (((NumChiusiRE / NumEntratiRE) * 100) - Math.floor(((NumChiusiRE / NumEntratiRE) * 100))) !== 0
                                            ? ((NumChiusiRE / NumEntratiRE) * 100).toFixed(2)
                                            : ((NumChiusiRE / NumEntratiRE) * 100).toFixed(0),
                            NumSinistriMancantiRE: NumChiusiRE - calcolaSinistriObiettivo(NumEntratiRE, 'RE'),
                            TempoMedioScaricoRE: NumChiusiRE === 0 ? 0 : parseFloat(PesoParzialeRE / NumChiusiRE).toFixed(2),
                            ScarTotSinRC: ((NumChiusiRC / NumEntratiRC) * 100) < 100 && ((NumChiusiRC / NumEntratiRC) * 100) > 0 
                            && (((NumChiusiRC / NumEntratiRC) * 100) - Math.floor(((NumChiusiRC / NumEntratiRC) * 100))) !== 0
                                            ? ((NumChiusiRC / NumEntratiRC) * 100).toFixed(2)
                                            : ((NumChiusiRC / NumEntratiRC) * 100).toFixed(0),
                            NumSinistriMancantiRC: NumChiusiRC - calcolaSinistriObiettivo(NumEntratiRC, 'RC'),
                            TempoMedioScaricoRC: NumChiusiRC === 0 ? 0 : parseFloat(PesoParzialeRC / NumChiusiRC).toFixed(2)
                        });  
                        NumChiusiRE = 0; NumEntratiRE = 0; PesoParzialeRE = 0;
                        NumChiusiRC = 0; NumEntratiRC = 0; PesoParzialeRC = 0;
                    }
                    if (elm.Raggruppamento === 'RE') {
                        NumChiusiRE += elm.NumSinistriChiusi;
                        NumEntratiRE += elm.NumSinistriEntrati;
                        PesoParzialeRE += (elm.GiorniMediRientro * elm.NumSinistriChiusi);
                    }
                    else {
                        NumChiusiRC += elm.NumSinistriChiusi;
                        NumEntratiRC += elm.NumSinistriEntrati;
                        PesoParzialeRC += (elm.GiorniMediRientro * elm.NumSinistriChiusi);
                    }  
                    salvaIdPerito = elm.IdPerito;
                    salvaIdCompagnia = elm.IdCompagnia;   
                    salvaNomePerito = elm.NominativoPerito;             
                    periti.push({ Value: elm.IdPerito.toString(), Text: elm.NominativoPerito });               
                });             
                GridData2.push({
                    IdCompagnia: salvaIdCompagnia,
                    IdPerito: salvaIdPerito,
                    NominativoPerito: salvaNomePerito,                    
                    ScarTotSinRE: ((NumChiusiRE / NumEntratiRE) * 100) < 100 && ((NumChiusiRE / NumEntratiRE) * 100) > 0 
                                    && (((NumChiusiRE / NumEntratiRE) * 100) - Math.floor(((NumChiusiRE / NumEntratiRE) * 100))) !== 0
                                    ? ((NumChiusiRE / NumEntratiRE) * 100).toFixed(2)
                                    : ((NumChiusiRE / NumEntratiRE) * 100).toFixed(0),
                    NumSinistriMancantiRE: NumChiusiRE - calcolaSinistriObiettivo(NumEntratiRE, 'RE'),
                    TempoMedioScaricoRE: NumChiusiRE === 0 ? 0 : parseFloat(PesoParzialeRE / NumChiusiRE).toFixed(2),
                    ScarTotSinRC: ((NumChiusiRC / NumEntratiRC) * 100) < 100 && ((NumChiusiRC / NumEntratiRC) * 100) > 0 
                                    && (((NumChiusiRC / NumEntratiRC) * 100) - Math.floor(((NumChiusiRC / NumEntratiRC) * 100))) !== 0
                                    ? ((NumChiusiRC / NumEntratiRC) * 100).toFixed(2)
                                    : ((NumChiusiRC / NumEntratiRC) * 100).toFixed(0), 
                    NumSinistriMancantiRC: NumChiusiRC - calcolaSinistriObiettivo(NumEntratiRC, 'RC'),
                    TempoMedioScaricoRC: NumChiusiRC === 0 ? 0 : parseFloat(PesoParzialeRC / NumChiusiRC).toFixed(2)
                });   
                GridData2 = _.sortBy(GridData2, obj => { return obj.NumSinistriMancantiRE + obj.NumSinistriMancantiRC; }); 
                localStorage.setItem("MonitorDSObiettiviSecondoLiv", JSON.stringify(GridData2));               
                periti.unshift({ Value: '', Text: '' }); 
                periti = _.uniq(periti, elm => elm.Value);        
                document.getElementById('GridObiettivi').ej2_instances[0].dataSource = GridData1;
                document.getElementById('GridObiettivi').ej2_instances[0].childGrid.dataSource = GridData2; 
                document.getElementById('GridObiettivi').ej2_instances[0].refresh();             
                document.getElementById('ddlPeriti').ej2_instances[0].dataSource = periti;
                //thisClone.toggleBlocking();
        }, true, false);
        
        CustomJS.getRemoteData2(CustomJS.APIUrlProd,
            `token=${CustomJS.tokenProd}&azione=scaricoCompagnie&raggruppamento=rerc-mese`, 
            'POST', "application/x-www-form-urlencoded", (retData) => { 
                retData = _.filter(retData, elm => { return elm.NominativoPerito !== 'TOTALI' });
                let groupedArr = _.groupBy(retData, 'periodo');
                let calcoloCumulMese = (meseFinale, raggr) => { 
                    let totEntrati = 0, totChiusi = 0;
                    for (let ind=0;ind<=meseFinale;ind++) {
                        totEntrati += !_.isArray(Object.values(groupedArr)[ind]) ? 0 : Object.values(groupedArr)[ind].sum('NumSinistriEntrati', raggr);
                        totChiusi += !_.isArray(Object.values(groupedArr)[ind]) ? 0 : Object.values(groupedArr)[ind].sum('NumSinistriChiusi', raggr);
                    }  
                    return meseFinale > new Date().getMonth() ? 0 : parseFloat(totChiusi/totEntrati*100).toFixed(2)
                }
                for (let ind=1; ind<=12;ind++) {  
                    ObietMese = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RE'})[yyyy.toString() + ind.toString().padStart(2,'0')];
                    data1.push({ x: ind === 1 ? new Date(yyyy, 0, 1) : ind === 2 ? new Date(yyyy, 1, 1)  : ind === 3 ? new Date(yyyy, 2, 1)  : ind === 4 ? new Date(yyyy, 3, 1)
                                : ind === 5 ? new Date(yyyy, 4, 1)  : ind === 6 ? new Date(yyyy, 5, 1) : ind === 7 ? new Date(yyyy, 6, 1)  : ind === 8 ? new Date(yyyy, 7, 1)  
                                : ind === 9 ? new Date(yyyy, 8, 1)  : ind === 10 ? new Date(yyyy, 9, 1)  : ind === 11 ? new Date(yyyy, 10, 1)  : new Date(yyyy, 11, 1), y: ObietMese  }); 
                    data2.push({ x: ind === 1 ? new Date(yyyy, 0, 1) : ind === 2 ? new Date(yyyy, 1, 1) : ind === 3 ? new Date(yyyy, 2, 1) : ind === 4 ? new Date(yyyy, 3, 1) : ind === 5 ? new Date(yyyy, 4, 1) : ind === 6 ? new Date(yyyy, 5, 1) 
                                : ind === 7 ? new Date(yyyy, 6, 1) : ind === 8 ? new Date(yyyy, 7, 1) : ind === 9 ? new Date(yyyy, 8, 1) : ind === 10 ? new Date(yyyy, 9, 1) : ind === 11 ? new Date(yyyy, 10, 1) : new Date(yyyy, 11, 1), y: calcoloCumulMese(ind-1, 'RE') }); 
                }  
                for (let ind=1; ind<=12;ind++) {  
                    ObietMese = _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RC'})[yyyy.toString() + ind.toString().padStart(2,'0')];
                    data3.push({ x: ind === 1 ? new Date(yyyy, 0, 1) : ind === 2 ? new Date(yyyy, 1, 1)  : ind === 3 ? new Date(yyyy, 2, 1)  : ind === 4 ? new Date(yyyy, 3, 1)
                                : ind === 5 ? new Date(yyyy, 4, 1)  : ind === 6 ? new Date(yyyy, 5, 1) : ind === 7 ? new Date(yyyy, 6, 1)  : ind === 8 ? new Date(yyyy, 7, 1)  
                                : ind === 9 ? new Date(yyyy, 8, 1)  : ind === 10 ? new Date(yyyy, 9, 1)  : ind === 11 ? new Date(yyyy, 10, 1)  : new Date(yyyy, 11, 1), y: ObietMese  }); 
                    data4.push({ x: ind === 1 ? new Date(yyyy, 0, 1) : ind === 2 ? new Date(yyyy, 1, 1) : ind === 3 ? new Date(yyyy, 2, 1) : ind === 4 ? new Date(yyyy, 3, 1) : ind === 5 ? new Date(yyyy, 4, 1) : ind === 6 ? new Date(yyyy, 5, 1) 
                                : ind === 7 ? new Date(yyyy, 6, 1) : ind === 8 ? new Date(yyyy, 7, 1) : ind === 9 ? new Date(yyyy, 8, 1) : ind === 10 ? new Date(yyyy, 9, 1) : ind === 11 ? new Date(yyyy, 10, 1) : new Date(yyyy, 11, 1), y: calcoloCumulMese(ind-1, 'RC') }); 
                }   
                data2 = _.filter(data2, elm => { return elm.y > 0 });
                data4 = _.filter(data4, elm => { return elm.y > 0 });
                document.getElementById('ChartObiettRE').ej2_instances[0].series[0].dataSource = data1;
                document.getElementById('ChartObiettRE').ej2_instances[0].series[1].dataSource = data2;
                document.getElementById('ChartObiettRC').ej2_instances[0].series[0].dataSource = data3;
                document.getElementById('ChartObiettRC').ej2_instances[0].series[1].dataSource = data4;
        }, true, false);
}

function calcolaSinistriObiettivo(sinistriEntrati, ramo) {
    if (sinistriEntrati === 0)
        return 0;
    for (let ind=1;;ind++) {
        let scaricoSimul = Math.floor(((ind / sinistriEntrati) * 100));
        if ((scaricoSimul === parseInt(ObietMeseRE) && ramo === 'RE')
            || (scaricoSimul === parseInt(ObietMeseRC) && ramo === 'RC'))
            return ind;   
        else if ((scaricoSimul >= parseInt(ObietMeseRE) && ramo === 'RE')
                || (scaricoSimul >= parseInt(ObietMeseRC) && ramo === 'RC')) 
                return ind;             
    }
}
        
function headerTemplate(props) {   
    return (<div>
        <span style={{ fontSize: '1.0vw', fontWeight: 'bolder' }}>{props.headerText}</span>
   </div>);
}

export default class PaginaObiettivi extends SampleBase {
    constructor() {
        super(...arguments);  
        this.toolbarOptions = ['ExcelExport', { template: this.ddlStatiToolbar.bind(this) }, '    ', { template: this.chkPeritiObiettToolbar.bind(this) }, '    ', { template: this.chkPeritiNoObiettToolbar.bind(this) }]; 
        this.childGrid = {
            queryString: 'IdCompagnia',
            allowPaging: true,
            allowSelection: false,
            enableHover: false,
            pageSettings: { pageSize: 10, pageCount: 5 },
            toolbar: [ 'ExcelExport', 'Search' ],
            columns: [
                { field: 'NominativoPerito', headerText: 'Nominativo Perito', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'ScarTotSinRE', headerText: 'Scarico Totale RE', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'NumSinistriMancantiRE', headerText: 'Sinistri Mancanti RE', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'TempoMedioScaricoRE', headerText: 'Tempo Medio Scarico RE', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'ScarTotSinRC', headerText: 'Scarico Totale RC', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'NumSinistriMancantiRC', headerText: 'Sinistri Mancanti RC', headerTemplate: headerTemplate, textAlign: 'Center' },
                { field: 'TempoMedioScaricoRC', headerText: 'Tempo Medio Scarico RC', headerTemplate: headerTemplate, textAlign: 'Center' },
            ], 
            queryCellInfo: this.onQueryCellInfo2.bind(this),
            dataBound: this.onDatabound2
        };
        this.ddlFields = { text: 'Text', value: 'Value' };
        this.mesi = [{Text: mesiChar[0], Value: '01'}, {Text: mesiChar[1], Value: '02'}, {Text: mesiChar[2], Value: '03'}, {Text: mesiChar[3], Value: '04'}, 
                    {Text: mesiChar[4], Value: '05'}, {Text: mesiChar[5], Value: '06'}, {Text: mesiChar[6], Value: '07'}, {Text: mesiChar[7], Value: '08'}, 
                    {Text: mesiChar[8], Value: '09'}, {Text: mesiChar[9], Value: '10'}, {Text: mesiChar[10], Value: '11'}, {Text: mesiChar[11], Value: '12'}];
        this.ddlMesiFiltr = _.filter(this.mesi, elm => { return parseInt(elm.Value) <= parseInt(mm) }); 
        this.toggleBlocking = this.toggleBlocking.bind(this);
        this.loaderType = ['Ball-Triangle', 'Bars', 'Circles', 'Grid', 'Puff', 'Rings', 'TailSpin', 'ThreeDots', 'Oval', 'MutatingDots', 'RevolvingDot'];
    }  
    state = {
        blocking2: false,    
        meseAtt: mesiChar[parseInt(mm)-1], 
        ObietMeseREatt: ObietMeseRE,
        ObietMeseRCatt: ObietMeseRC  
    }   
    toggleBlocking() {
        this.setState({blocking2: !this.state.blocking2});
    }
    onQueryCellInfo(args) {
        args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
        args.cell.style.fontSize = args.column.index === 0 ? '1.3vw' : '1.0vw';
        args.cell.style.fontWeight = 'bold'; 
        if (args.column.index === 1 ||  args.column.index === 2 ||  args.column.index === 3 ||  args.column.index === 4 ||  args.column.index === 5 ||  args.column.index === 6)
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT'); 
        if (args.column.index === 1 ||  args.column.index === 4) {
            args.cell.innerText = args.cell.innerText + '%' ;
        }
        if (args.cell.innerText === 'NaN' || args.cell.innerText === '%' || args.cell.innerText === 'NaN%')
            args.cell.innerText = '';  
        if ((args.column.index === 2 || args.column.index === 5) && (parseInt(args.cell.innerText) > 0)) {    
            args.cell.style.color = 'whitesmoke';  
            args.cell.bgColor = '#00802B';          
        }
        if ((args.column.index === 2 ||  args.column.index === 5) && (parseInt(args.cell.innerText) < 0)) {    
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }     
    }    
    onQueryCellInfo2(args) {
        args.cell.style.color = args.column.index === 0 ? '#133B95' : 'purple';
        args.cell.style.fontSize = '1.0vw';
        args.cell.style.fontWeight = 'bold';   
        if (args.column.index === 1 ||  args.column.index === 2 ||  args.column.index === 3 ||  args.column.index === 4 ||  args.column.index === 5 ||  args.column.index === 6)
            args.cell.innerText = parseFloat(args.cell.innerText).toLocaleString('it-IT');  
        if (args.column.index === 1 ||  args.column.index === 4)
            args.cell.innerText = args.cell.innerText + '%' ; 
        if (args.cell.innerText === 'NaN' || args.cell.innerText === '%' || args.cell.innerText === 'NaN%')
            args.cell.innerText = ''; 
        if ((args.column.index === 2 ||  args.column.index === 5) && (parseInt(args.cell.innerText) > 0)) {    
            args.cell.style.color = 'whitesmoke';    
            args.cell.bgColor = '#00802B';
        }  
        if ((args.column.index === 2 ||  args.column.index === 5) && (parseInt(args.cell.innerText) < 0)) {    
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#DC143C';
        }                                   
    }     
    onDatabound(args) {       
        for (let ind=0;ind<=7;ind++)
             document.getElementById('GridObiettivi').querySelectorAll('.e-columnheader')[0].children[ind].style.backgroundColor = 'Linen';  
        document.getElementById('TestoDatiAggiornati').innerText =  'Dati aggiornati al ' + new Date().getDate().toString().padStart(2, '0') + '/' + (new Date().getMonth() + 1).toString().padStart(2, '0') + '/' + new Date().getFullYear().toString() + ' alle ore '  + new Date().getHours().toString() + ':' + new Date().getMinutes().toString().padStart(2, '0');         
    }    
    onDatabound2(args) {  
        for (let ind=0;ind<=6;ind++)
             this.element.querySelectorAll('.e-columnheader')[0].children[ind].style.backgroundColor = 'Linen';       
    }  
    toolbarClick(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstance.pdfExport();
                break;
                case 'e-excelexport':
                    this.gridInstance.excelExport();
                    break;
                }
    }
    onRowDatabound(args) {       
        const filter = args.data.IdCompagnia;
        const childrecord = new DataManager(this.childGrid.dataSource)
        .executeLocal(new Query().where("IdCompagnia", "equal", filter, true));
        if (childrecord.length === 0) {
            args.row.querySelector('td').innerHTML=" ";
            args.row.querySelector('td').className = "e-customizedExpandcell";
        }
    }
    ddlStatiToolbar(args) {                
        return (
            <div id='divDDL'></div>);        
    }
    chkPeritiObiettToolbar(args) { 
        return (
            <div id='divCHK1'></div>);   
    }
    chkPeritiNoObiettToolbar(args) { 
        return (
            <div id='divCHK2'></div>);   
    }
    onCreated(args) {
        ReactDOM.render(<DropDownListComponent id='ddlPeriti' fields={this.ddlFields} ref={ ddlObj => this.ddlInstance = ddlObj } dataSource={this.periti} change={this.onChangePerito.bind(this)} allowFiltering={true} filterType='Contains'
                style={{width: '20vw'}} placeholder="Selezionare un perito da visualizzare" floatLabelType='always' popupHeight="250px" cssClass='e-outline' />, document.getElementById('divDDL'), () => {                 
                });
        ReactDOM.render(<CheckBoxComponent id='chkPeritiObiett' label='Visualizza periti CON obiettivo raggiunto' style={{ marginLeft: '30px'}} change={this.onChangeChkPeritiObiett} />, document.getElementById('divCHK1'), () => {                 
        });
        ReactDOM.render(<CheckBoxComponent id='chkPeritiNoObiett' label='Visualizza periti SENZA obiettivo raggiunto' change={this.onChangeChkPeritiNoObiett} />, document.getElementById('divCHK2'), () => {                 
        });
    }
    onChangePerito(args) {
        let arrFiltrato = [];        
        if (CustomJS.isNullEmpty(args.value))
            arrFiltrato = JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv"));
        else
            arrFiltrato = _.filter(JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv")), elm => { return elm.IdPerito.toString() === args.value; });
        document.getElementById('GridObiettivi').ej2_instances[0].childGrid.dataSource = arrFiltrato; 
        document.getElementById('GridObiettivi').ej2_instances[0].refresh(); 
        setTimeout(() => {
            if (!CustomJS.isNullEmpty(args.value))
                document.getElementById('GridObiettivi').querySelectorAll('td.e-detailrowcollapse').forEach(elm => { 
                    elm.click();
                });
            document.getElementById('chkPeritiObiett').ej2_instances[0].checked = false;
            document.getElementById('chkPeritiObiett').ej2_instances[0].disabled = !CustomJS.isNullEmpty(args.value);
            document.getElementById('chkPeritiNoObiett').ej2_instances[0].checked = false;
            document.getElementById('chkPeritiNoObiett').ej2_instances[0].disabled = !CustomJS.isNullEmpty(args.value);
        }, 400);        
    }
    onChangeChkPeritiObiett(args) {
        let arrFiltrato = [];
        if (!args.checked)
            arrFiltrato = JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv"));
        else
            arrFiltrato = _.filter(JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv")), elm => { return parseInt(elm.NumSinistriMancantiRE) > 0 || parseInt(elm.NumSinistriMancantiRC) > 0; });
        document.getElementById('GridObiettivi').ej2_instances[0].childGrid.dataSource = arrFiltrato; 
        document.getElementById('GridObiettivi').ej2_instances[0].refresh(); 
        setTimeout(() => {
            if (args.checked)
            document.getElementById('GridObiettivi').querySelectorAll('td.e-detailrowcollapse').forEach(elm => { 
                elm.click();
            });
            document.getElementById('ddlPeriti').ej2_instances[0].enabled = !args.checked;
            document.getElementById('chkPeritiNoObiett').ej2_instances[0].disabled = args.checked;
        }, 400);     
    }
    onChangeChkPeritiNoObiett(args) {
        let arrFiltrato = [];
        if (!args.checked)
            arrFiltrato = JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv"));
        else
            arrFiltrato = _.filter(JSON.parse(localStorage.getItem("MonitorDSObiettiviSecondoLiv")), elm => { return parseInt(elm.NumSinistriMancantiRE) < 0 && parseInt(elm.NumSinistriMancantiRC) < 0; });
        document.getElementById('GridObiettivi').ej2_instances[0].childGrid.dataSource = arrFiltrato; 
        document.getElementById('GridObiettivi').ej2_instances[0].refresh(); 
        setTimeout(() => {
            if (args.checked)
            document.getElementById('GridObiettivi').querySelectorAll('td.e-detailrowcollapse').forEach(elm => { 
                elm.click();
            });
            document.getElementById('ddlPeriti').ej2_instances[0].enabled = !args.checked;
            document.getElementById('chkPeritiObiett').ej2_instances[0].disabled = args.checked;
        }, 400);     
    }
    onChangeMese(args) {
        this.setState({
            meseAtt: args.itemData.Text,
            ObietMeseREatt: _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RE'})[yyyy.toString() + args.value],
            ObietMeseRCatt: _.find(CurvaObiettivi.CurvaObiettivi, elm => { return elm.RAMO === 'RC'})[yyyy.toString() + args.value]
        });
        setTimeout(() => {
            caricaDati(this);
            this.ddlInstance.enabled = true;
            this.ddlInstance.value = '';
            document.getElementById('chkPeritiObiett').ej2_instances[0].checked = false;
            document.getElementById('chkPeritiNoObiett').ej2_instances[0].checked = false;
        }, 300);        
    }

    render() {
        return (<React.Fragment>
            <div className='container-fluid'>   
                <div className='row'>
                    <div className="col-xs-12 col-sm-12 col-lg-2 col-md-2 text-center" style={{ marginLeft: '50px', marginTop: '15px', marginBottom: '15px' }}>
                        <span style={{ fontSize: '2.0vw', fontWeight: 'bolder', color:'#133B95'}}>{ this.state.meseAtt + ' ' +  yyyy.toString()}</span>
                    </div> 
                    <div className="col-xs-12 col-sm-12 col-lg-6 col-md-6 text-center" style={{ marginTop: '15px', marginBottom: '15px'}}>
                        <span id='testoChiusiAnnoCorr' style={{ fontSize: '1.5vw', fontWeight: 'bolder', color:'#133B95'}}>OBIETTIVO MENSILE RE: {this.state.ObietMeseREatt}%&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OBIETTIVO MENSILE RC: {this.state.ObietMeseRCatt}% </span>
                    </div> 
                </div> 
                <div className='row'>
                    <div className="col-xs-12 col-sm-12 offset-lg-9 col-lg-3 offset-md-7 col-md-5">
                        <DropDownListComponent id='ddlMesi' fields={this.ddlFields} ref={ ddlObj => this.ddlInstance2 = ddlObj } enabled={false} dataSource={this.ddlMesiFiltr} change={this.onChangeMese.bind(this)}
                             placeholder="Selezionare un mese da visualizzare" floatLabelType='always' popupHeight="250px" cssClass='e-outline'></DropDownListComponent>
                    </div>
                </div> 
                <div className='row'>
                    <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <BlockUi tag='div' blocking={this.state.blocking2} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}> 
                            <GridComponent id="GridObiettivi" ref={grid => this.gridInstance = grid} toolbar={this.toolbarOptions} childGrid={this.childGrid} allowSelection={false} enableHover={false} allowTextWrap={true} 
                                allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfo.bind(this)} pageSettings={{ pageCount: 5, pageSize: 10, pageSizes: ['10', '50', 'Tutti'] }}
                                dataBound={this.onDatabound.bind(this)} toolbarClick={this.toolbarClick.bind(this)} rowDataBound={this.onRowDatabound} enableAltRow={true} gridLines='Both' hierarchyPrintMode='All' created={this.onCreated.bind(this)}>
                                    <ColumnsDirective>
                                        <ColumnDirective field='DescrCompagnia' headerText='Compagnia' headerTemplate={headerTemplate} textAlign='Center' width='22%'></ColumnDirective>
                                        <ColumnDirective field='ScarTotSinRE' headerText='Scarico Totale RE' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                        <ColumnDirective field='NumSinistriMancantiRE' headerText='Sinistri Mancanti RE' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                        <ColumnDirective field='TempoMedioScaricoRE' headerText='Tempo Medio Scarico RE' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                        <ColumnDirective field='ScarTotSinRC' headerText='Scarico Totale RC' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                        <ColumnDirective field='NumSinistriMancantiRC' headerText='Sinistri Mancanti RC' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                        <ColumnDirective field='TempoMedioScaricoRC' headerText='Tempo Medio Scarico RC' headerTemplate={headerTemplate} textAlign='Center'></ColumnDirective>
                                    </ColumnsDirective>
                                <Inject services={[Toolbar, DetailRow, ExcelExport, PdfExport, Filter, Sort, Page]}/>                    
                            </GridComponent>  
                        </BlockUi>
                    </div>
                </div>
                <div className="row"  style={{ marginTop: '50px', marginBottom: '20px', display: 'none' }}>   
                    <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span style={{ fontSize: '1.6vw', fontWeight: 'bold', color:'#133B95'}}>Confronto andamento obiettivi/risultati sinistri RE</span>
                    </div>               
                </div> 
                <div className='row' style={{ display: 'none' }}>
                    <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <ChartComponent id='ChartObiettRE' style={{ textAlign: "center" }}
                            className='col-xs-12 col-sm-12 col-lg-12 col-md-12'
                            ref={chart => {this.chartInstance1 = chart}}
                            primaryXAxis={{
                                valueType: 'DateTime',
                                labelFormat: 'MMMM',
                                intervalType: 'Months',
                                edgeLabelPlacement: 'Shift',
                                majorGridLines: { width: 0 }                
                            }}
                            primaryYAxis={{
                                labelFormat: '{value}',
                                rangePadding: 'None',                                
                                interval: 10,
                                lineStyle: { width: 0 },                                
                                minimum: 0,
                                majorTickLines: { width: 0 },
                                minorTickLines: { width: 0 }
                            }}
                            chartArea={{ border: { width: 0 } }}
                            tooltip={{ enable: true }}
                            title='' 
                            width='97%'
                            legendSettings={{ visible: true }}>
                            <Inject services={[LineSeries, DateTime, Legend, Tooltip, Trendlines]} />
                            <SeriesCollectionDirective>
                                <SeriesDirective xName='x' yName='y' name={`Obiettivi mensili RE`}
                                    width={3} marker={{ visible: true, width: 10, height: 10 }} type='Line'>
                                </SeriesDirective>
                                <SeriesDirective xName='x' yName='y' name={`Risultati mensili RE`}
                                    width={3} marker={{ visible: true, width: 10, height: 10 }} type='Line'>
                                </SeriesDirective>
                            </SeriesCollectionDirective>
                        </ChartComponent>
                    </div>
                </div>
                <div className='row'  style={{ marginTop: '50px', marginBottom: '20px', display: 'none' }}>                       
                    <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span style={{ fontSize: '1.6vw', fontWeight: 'bold', color:'#133B95'}}>Confronto andamento obiettivi/risultati sinistri RC</span>
                    </div>        
                </div>    
                <div className='row' style={{ display: 'none' }}>
                    <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <ChartComponent id='ChartObiettRC' style={{ textAlign: "center"}}
                            className='col-xs-12 col-sm-12 col-lg-12 col-md-12'
                            ref={chart => {this.chartInstance1 = chart}}
                            primaryXAxis={{
                                valueType: 'DateTime',
                                labelFormat: 'MMMM',
                                intervalType: 'Months',
                                edgeLabelPlacement: 'Shift',
                                majorGridLines: { width: 0 }                
                            }}
                            primaryYAxis={{
                                labelFormat: '{value}',
                                rangePadding: 'None',                                
                                interval: 10,
                                lineStyle: { width: 0 },                                
                                minimum: 0,
                                majorTickLines: { width: 0 },
                                minorTickLines: { width: 0 }
                            }}
                            chartArea={{ border: { width: 0 } }}
                            tooltip={{ enable: true }}
                            width='97%'
                            title='' 
                            legendSettings={{ visible: true }}>
                            <Inject services={[LineSeries, DateTime, Legend, Tooltip, Trendlines]} />
                            <SeriesCollectionDirective>
                                <SeriesDirective xName='x' yName='y' name={`Obiettivi mensili RC`}
                                    width={3} marker={{ visible: true, width: 10, height: 10 }} type='Line'>
                                </SeriesDirective>
                                <SeriesDirective xName='x' yName='y' name={`Risultati mensili RC`}
                                    width={3} marker={{ visible: true, width: 10, height: 10 }} type='Line'>
                                </SeriesDirective>
                            </SeriesCollectionDirective>
                        </ChartComponent>
                    </div>
                </div>
            </div>
        </React.Fragment>);
    }      
    componentDidMount() {
        this.ddlInstance2.value = mm;
        //caricaDati();
    }
}
